module.exports = __webpack_public_path__ + "img/document-nothing-3.ad1e9d7b.svg";